// Terms of Service — localized (pt /terms, en /en/terms, es /es/terms).
// Content lives in src/i18n/legal/terms.ts; the shared LegalDocView
// renders it with per-locale <head> + hreflang.

import { LegalDocView } from "@/components/marketing/LegalDocView";
import { useLocale } from "@/i18n/LocaleProvider";
import { TERMS } from "@/i18n/legal/terms";

export function TermsPage() {
  const locale = useLocale();
  return <LegalDocView page="terms" doc={TERMS[locale]} />;
}
